import type { ScanAgeBucket } from "#/types/report";
import { Table } from "@mantine/core";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import ReportSection from "./ReportSection";

interface ScanAgeOverviewProps {
  buckets: ScanAgeBucket[];
  nonFieldItemCount: number;
  tooltip?: ReactNode;
}

const ScanAgeOverview = ({ buckets, nonFieldItemCount, tooltip }: ScanAgeOverviewProps) => {
  const { t } = useTranslation();

  return (
    <ReportSection
      title={t("reports.inventoryScan.scanAge.title")}
      subtitle={t("reports.inventoryScan.scanAge.itemCount", { count: nonFieldItemCount })}
      tooltip={tooltip}
    >
      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t("reports.inventoryScan.scanAge.range")}</Table.Th>
            <Table.Th className="text-right">{t("reports.inventoryScan.scanAge.items")}</Table.Th>
            <Table.Th className="text-right">{t("reports.inventoryScan.scanAge.percentage")}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {buckets.map((bucket) => (
            <Table.Tr key={bucket.label}>
              <Table.Td className="font-medium">{bucket.label}</Table.Td>
              <Table.Td className="text-right">{bucket.count}</Table.Td>
              <Table.Td className="text-right">{bucket.percentage}%</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </ReportSection>
  );
};

export default ScanAgeOverview;
